import { Language } from "../../commons/types";
import enMessages from "./en.json";
import frMessages from "./fr.json";

export const EnLang : Language = {
    id: 'en',
    locale: 'en',
    name: 'language.en',
    messages: enMessages,
};

export const FrLang : Language = {
    id: 'fr',
    locale: 'fr',
    name: 'language.fr',
    messages: frMessages,
};
